"use client";

import posthog from "posthog-js";
import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (posthog.__loaded) {
      posthog.captureException(error);
    }
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center">
      <span className="material-symbols-outlined text-5xl text-red-400">error</span>
      <h2 className="font-headline text-xl italic">Quelque chose s&apos;est mal passé</h2>
      <p className="text-stone-500 text-sm">
        Une erreur inattendue est survenue. Veuillez réessayer.
      </p>
      <button
        onClick={reset}
        className="rounded-full bg-stone-900 px-6 py-2.5 text-sm font-medium text-white"
      >
        Réessayer
      </button>
    </div>
  );
}
